import React from 'react'
import { useIntl } from 'react-intl'
import {
  ContentDownloadCode,
  stepSelectLinuxNormalize,
  stepInteractContrastUI
} from './common'
import { formatStyles } from '../../../../react-intl-helpers'
import { OPERATING_SYSTEM } from '../common/constants'
import { AgentDropdown } from '../agent-config'
import { getOrgUuid } from '../common/utils'

const commonFinalSteps = [stepInteractContrastUI]
const universalAgentKeyBranch = 'universal-agent-key'

const apiTemplate = `mkdir /etc/contrast &&
wget http://contrast-magic-installer.com -o /etc/contrast/universal-agent.zip &&
tar -xvf /etc/contrast/universal-agent.zip &&
sh /etc/contrast/universal-agent/setup.sh -t {agentUid}
`

const stepPasteYourInstall = {
  defaultIsOpen: true,
  titleMsg: 'title_pasteYourInstall',
  Content: () => (
    <ContentDownloadCode
      message="detail_pastYourInstallCode"
      codeTemplate={apiTemplate}
    />
  )
}

const stepSelectAgentKey = {
  defaultIsOpen: true,
  titleMsg: 'title_setAnAgentKey',
  branchKey: universalAgentKeyBranch,
  branches: {
    '*': [stepPasteYourInstall, ...commonFinalSteps]
  },
  Content: () => {
    const intl = useIntl()
    const orgUuid = getOrgUuid()

    return (
      <>
        {intl.formatMessage(
          { id: 'detail_setAnAgentKey' },
          {
            ...formatStyles.link({
              isExternal: false,
              href: `/Contrast/static/ng/index.html#/${orgUuid}/settings/api`
            }),
            ...formatStyles.doclink({ path: '/configuration-settings.html' })
          }
        )}
        <br />
        <AgentDropdown branchKey={universalAgentKeyBranch} />
      </>
    )
  }
}

export const universalWizardStepsNormalizeAgentDownload = [
  {
    ...stepSelectLinuxNormalize,
    branchKey: OPERATING_SYSTEM.KEY,
    branches: {
      linux: [stepSelectAgentKey]
    }
  }
]
